module.exports = __webpack_public_path__ + "img/live-chat-img.c657ede9.svg";